// extracted by mini-css-extract-plugin
export default {"discount":"cEtr8_S5K","amount":"cYel24eV_","sign":"czLHfBrst","smallFont":"ceod82o_T"};